import { render, staticRenderFns } from "./CompetitionItem.vue?vue&type=template&id=73c72eda&scoped=true&"
import script from "./CompetitionItem.vue?vue&type=script&lang=js&"
export * from "./CompetitionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c72eda",
  null
  
)

export default component.exports